
export const UpdateTaskPackage = (project, taskPackage, resultHandler) => {
  let getAPI = '/api/projects/taskPackages/'+ taskPackage.id.toString()+ '/update';
  if (process.env.NODE_ENV !== 'production') {
    getAPI = 'http://localhost:7071/api/projects/taskPackages/'+ taskPackage.id.toString()+ '/update';
  }
  fetch(getAPI, {
    method: 'POST',
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(project.toJS())
  }).then(response => {
    if (!response.ok) {
      response.text()
        .then(text => { throw Error(response.statusText + ': ' + text) });
    } else {
      response.json()
        .then(parsedResponse => resultHandler(parsedResponse));
    }
  });
}

export const UpdateActuals = (project, taskPackage, resultHandler) => {
  let getAPI = '/api/projects/taskPackages/'+ taskPackage.id.toString() +'/actuals/update';
  if (process.env.NODE_ENV !== 'production') {
    getAPI = 'http://localhost:7071/api/projects/taskPackages/'+ taskPackage.id.toString() + '/actuals/update';
  }
  fetch(getAPI, {
    method: 'POST',
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(project.toJS())
  }).then(response => {
    if (!response.ok) {
      response.text()
        .then(text => { throw Error(response.statusText + ': ' + text) });
    } else {
      response.json()
        .then(parsedResponse => resultHandler(parsedResponse));
    }
  });
}

export const GetPackageAnalysis = async (taskId, resultHandler) => {
  let getAPI = '/api/taskPackage/' + taskId + '/analysis';
  if (process.env.NODE_ENV !== 'production') {
    getAPI = 'http://localhost:7071' + getAPI;
  }
  const response = await fetch(getAPI, {
    method: 'GET',
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json'
    }
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(response.statusText + ': ' + text);
  } else {
    const parsedResponse = await response.json();
    resultHandler(parsedResponse);
  }
};

export const GetPackageFAC = async (taskId, resultHandler) => {
  let getAPI = '/api/taskPackage/' + taskId + '/FAC';
  if (process.env.NODE_ENV !== 'production') {
    getAPI = 'http://localhost:7071' + getAPI;
  }
  const response = await fetch(getAPI, {
    method: 'GET',
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json'
    }
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(response.statusText + ': ' + text);
  } else {
    const parsedResponse = await response.json();
    resultHandler(parsedResponse);
  }
};